export default __webpack_public_path__ + "static/media/AvailabilitySlots.fe78b707.svg";